var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isBrusselsZip, isFlemishZip } from "../../utils/property.utils";
// import { getStore } from "../../utils/redux/redux.utils";
import { getPagedId as getPagedIdBase, } from "../generic/paged.utils";
import { 
// ETemplateAccessScope,
ETemplateRegionBelgium, } from "./template.types";
export var getPagedId = function (params) {
    return getPagedIdBase(__assign(__assign({}, params), { entityName: "template" }));
};
export var getRegionByZip = function (zip) {
    if (isBrusselsZip(zip)) {
        return ETemplateRegionBelgium.Brussels;
    }
    if (isFlemishZip(zip)) {
        return ETemplateRegionBelgium.Flanders;
    }
    return ETemplateRegionBelgium.Wallonia;
};
// const getTenantContact = (id?: number) => {
//   if (!id) {
//     return;
//   }
//   const store = getStore();
//   if (!store) {
//     return;
//   }
//   const contactForMember = contactSelectors.getContact(
//     store.getState(),
//     undefined,
//     id,
//   );
//   if (!contactForMember) {
//     return;
//   }
//   return contactForMember;
// };
// const matchesLocaleOrEmpty = (templateLocale?: ELocale, desired?: ELocale) =>
//   !templateLocale || templateLocale === desired;
export var sortTemplatesByRegionAndLocale = function (_a) {
    // const privateTemplates = templates.filter(
    //   template => template.accessScope === ETemplateAccessScope.Private,
    // );
    var templates = _a.templates, property = _a.property, tenantId = _a.tenantId;
    // const publicTemplates = templates.filter(
    //   template => template.accessScope !== ETemplateAccessScope.Private,
    // );
    // if (!property?.zip) return [...privateTemplates, ...publicTemplates];
    // const region: ETemplateRegionBelgium = getRegionByZip(property.zip);
    // // const tenantContact = getTenantContact(tenantId);
    // let filteredPublicTemplates: ITemplate[];
    // let filteredPrivateTemplates: ITemplate[];
    // switch (region) {
    //   case ETemplateRegionBelgium.Flanders:
    //     filteredPublicTemplates = publicTemplates.filter(
    //       template => template.region === ETemplateRegionBelgium.Flanders,
    //     );
    //     filteredPrivateTemplates = privateTemplates.filter(
    //       template => template.region === ETemplateRegionBelgium.Flanders,
    //     );
    //     break;
    //   case ETemplateRegionBelgium.Wallonia:
    //     filteredPublicTemplates = publicTemplates.filter(
    //       template => template.region === ETemplateRegionBelgium.Wallonia,
    //     );
    //     filteredPrivateTemplates = privateTemplates.filter(
    //       template => template.region === ETemplateRegionBelgium.Wallonia,
    //     );
    //     break;
    //   default:
    //     filteredPublicTemplates = publicTemplates.filter(
    //       template => template.region === ETemplateRegionBelgium.Brussels,
    //     );
    // .sort((a, b) => {
    //   if (!tenantContact?.locale) return 0;
    //   if (
    //     a.locale === tenantContact.locale &&
    //     b.locale !== tenantContact.locale
    //   ) {
    //     return -1;
    //   }
    //   if (
    //     b.locale === tenantContact.locale &&
    //     a.locale !== tenantContact.locale
    //   ) {
    //     return 1;
    //   }
    //   return 0;
    // });
    // filteredPrivateTemplates = privateTemplates.filter(
    //   template => template.region === ETemplateRegionBelgium.Brussels,
    // );
    // .sort((a, b) => {
    //   if (!tenantContact?.locale) return 0;
    //   if (
    //     a.locale === tenantContact.locale &&
    //     b.locale !== tenantContact.locale
    //   ) {
    //     return -1;
    //   }
    //   if (
    //     b.locale === tenantContact.locale &&
    //     a.locale !== tenantContact.locale
    //   ) {
    //     return 1;
    //   }
    //   return 0;
    // });
    //     break;
    // }
    return templates;
};
